//GlobalStateProvider.jsx

import React, { createContext, useState, useContext, useEffect, useRef} from 'react';

import axios from 'axios';
import { axiosInstance } from '../../lib/axiosInstance';


const GlobalStateContext = createContext();    //Creating a global state for authentication status.


//Use the context provider to wrap your application so that the authentication state is available to all components.
//AuthProvider is a component. It's basically SharedStateProvider.
export const GlobalStateProvider = ({ children }) => {

  const profilePicRef = useRef(null);
  const bookWithFriendsButtonRef = useRef(null);
  const bookWithStrangersButtonRef = useRef(null);
  const subjectSearchbarInputRef = useRef(null);




  /*----------------To set true if mobile screen---------------------*/

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025); //768   //1024  //Keeping 1025 helps in getting a smooth transition at 1024px.  

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1025);   //1024   //Keeping 1025 helps in getting a smooth transition at 1024px. 
    };

    window.addEventListener('resize', handleResize);

    // Cleanup listener on component unmount.      React will call this function later to clean up side effects when the component re-renders or unmounts.
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  console.log("isMobile : " + isMobile);






  //---------------state for heightOfCalendarGrid----------------
  const [heightOfCalendarGrid, setHeightOfCalendarGrid] = useState();  //0

    










  /*----------------To set show or not show ProfilePicDropDown--------------------*/

  const [showProfilePicDropDown, setShowProfilePicDropDown] = useState(false);
  //console.log("showProfilePicDropDown : " + showProfilePicDropDown);



  /*----------------To set show or not show MyProfile--------------------*/

  const [showMyProfile, setShowMyProfile] = useState(false);
  //console.log("showProfilePicDropDown : " + showProfilePicDropDown);


  /*----------------To set show or not show Notification--------------------*/

  const [showNotification, setShowNotification] = useState(false);
  //console.log("showProfilePicDropDown : " + showProfilePicDropDown);

    

  /*----------------To set show or not show Settings--------------------*/

  const [showSettings, setShowSettings] = useState(false);
  //console.log("showProfilePicDropDown : " + showProfilePicDropDown);





  



  /*----------------To set show or not show friends list--------------------*/

  const [showFriendsList, setShowFriendsList] = useState(false);
  //console.log("showFriendsList : " + showFriendsList);





  /*----------------To set show or not show strangers list--------------------*/

  const [showStrangersList, setShowStrangersList] = useState(false);
  //console.log("showStrangersList : " + showStrangersList);





  /*----------------To set All true or false.---------------------*/
  const [isAllSessionsClicked, setIsAllSessionsClicked] = useState(false);








  /*----------------To set the selected category---------------------*/

  const [category, setCategory] = useState(() => {
    const storedCategory = localStorage.getItem('category'); 
    return storedCategory ? storedCategory : 'discuss_and_learn';   //silent_study
  }); 

  //Not necessary I guess.
  /*
  useEffect(() => {
    const storedCategoryState = localStorage.getItem('category');   //Get the isAuthenticated value from the local storage.
    if (storedCategoryState) {
      setCategory(storedCategoryState);
    }
  }, []);     //The empty array [] means this useEffect will run only once, when the component mounts.
  */

  const setCategoryFn = (cat) => {
    setCategory(cat);    //I guess this is taking some time to set.
    localStorage.setItem('category', cat);
  };


  





  /*----------------To set the selected subject---------------------*/

  const [subject, setSubject] = useState(() => {
    const storedSubject = localStorage.getItem('subject'); 
    return storedSubject ? storedSubject : 'Medicine';    //Set it as the first subject in the pinned subject.
  }); 

  //Not necessary I guess.
  /*
  useEffect(() => {
    const storedSubjectState = localStorage.getItem('subject');   //Get the isAuthenticated value from the local storage.
    if (storedSubjectState ) {
      setCategory(storedSubjectState);
    }
  }, []);     //The empty array [] means this useEffect will run only once, when the component mounts.
  */

  /*
  const setSubjectFn = (e) => {
    setSubject(e.currentTarget.getAttribute('name'));    //I guess this is taking some time to set.
    localStorage.setItem('subject', e.currentTarget.getAttribute('name'));
  };
  */

  const setSubjectFn = (s) => {
    setSubject(s);    //I guess this is taking some time to set.
    localStorage.setItem('subject', s);
  };


  





  /*----------------To set the pinned subjects and all subjects---------------------*/
  //Default pinned subjects for new users. Should it be put/stored here or as a separate list in the backend? Or be assigned to the user when he/she signs up?
  const [pinnedSubjects, setPinnedSubjects] = useState(['Guitar', 'Medicine', 'Mechanical engineering', 'Computer/software engineering', 'Chartered accountancy']);        //{JSON.stringify(data, null, 2)}   when you write the data. 
  //const [pinnedSubjects, setPinnedSubjects] = useState([]);
  //console.log("pinnedSubjects : "+pinnedSubjects);


  const [allSubjects, setAllSubjects] = useState([]);




  /*----------------To set contact info-------------------*/

  const [contact, setContact] = useState({
    email: "",
    password: ""
  });






  /*----------------To set clickedGridTimeInDayHourMinute-------------------*/
  const [clickedGridTimeInDayHourMinute, setClickedGridTimeInDayHourMinute] = useState({});





  /*----------------To set topic-------------------*/
  const [topic, setTopic] = useState('');




  /*----------------To set CalendarMonthYear-------------------*/
  const [calendarMonthAndYear, setCalendarMonthAndYear] = useState('');


  /*----------------To set smallCalendarSelectedDate-------------------*/
  //const [smallCalendarSelectedDate, setSmallCalendarSelectedDate] = useState(Date.now());   // store as Unix timestamp
  const [smallCalendarSelectedDate, setSmallCalendarSelectedDate] = useState(new Date());  


  /*----------------To know if the profile is saved or not-------------------*/
  const [isSaved, setIsSaved] = useState(false);





  /*----------------State for the array of dates of the calendar-------------------*/
  const [datesWithDayMonthYear, setDatesWithDayMonthYear] = useState([{'dayNumber':'','month':'','year':''}]);





  const [bookedPersonArray, setBookedPersonArray]=useState([]); 

  


  const [isSilentStudyBookingDone, setIsSilentStudyBookingDone] = useState();


  /*-------------------------return--------------------------------*/

  return (     //isAuthenticated and token are states. And login and logout are functions.
    <GlobalStateContext.Provider value={{profilePicRef, 
                                        bookWithFriendsButtonRef,
                                        bookWithStrangersButtonRef, 
                                        subjectSearchbarInputRef, 
                                        isMobile, 
                                        isAllSessionsClicked,
                                        setIsAllSessionsClicked,
                                        category, 
                                        setCategoryFn, 
                                        allSubjects,
                                        setAllSubjects,
                                        pinnedSubjects, 
                                        setPinnedSubjects, 
                                        subject, 
                                        setSubjectFn, 
                                        showFriendsList, 
                                        setShowFriendsList, 
                                        showStrangersList, 
                                        setShowStrangersList, 
                                        heightOfCalendarGrid, 
                                        setHeightOfCalendarGrid, 
                                        showProfilePicDropDown, 
                                        setShowProfilePicDropDown,
                                        showMyProfile,
                                        setShowMyProfile,
                                        showNotification,
                                        setShowNotification,                                     
                                        showSettings,
                                        setShowSettings,
                                        contact,
                                        setContact,
                                        clickedGridTimeInDayHourMinute,
                                        setClickedGridTimeInDayHourMinute,
                                        topic,
                                        setTopic,
                                        calendarMonthAndYear,
                                        setCalendarMonthAndYear,
                                        smallCalendarSelectedDate,
                                        setSmallCalendarSelectedDate,
                                        isSaved, 
                                        setIsSaved,
                                        datesWithDayMonthYear, 
                                        setDatesWithDayMonthYear,
                                        bookedPersonArray,
                                        setBookedPersonArray,
                                        isSilentStudyBookingDone, 
                                        setIsSilentStudyBookingDone
                                        }}>
      {children}
    </GlobalStateContext.Provider>
  );
};







//useSharedState is a function I guess.
export const useGlobalState = () => {
  return useContext(GlobalStateContext);
};
